module.exports = __webpack_public_path__ + "img/samples.7571e95c.png";